import { useMemo } from 'react';

import { uniqueId } from '@ast/magma/inner/utils/uniqueid';

/**
 * Use Unique ID
 *
 * A hook that generates and returns a memoized prefixed unique ID.
 */
export function useUniqueId(prefix: string, deps?: React.DependencyList) {
  return useMemo(() => uniqueId(prefix), deps);
}
